import script from "./ContactManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactManagement.vue?vue&type=script&setup=true&lang=js"

import "./ContactManagement.vue?vue&type=style&index=0&id=6f080d92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f080d92"]])

export default __exports__